var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":"","id":_vm.pageName + '-container'}},[_c('div',{staticClass:"banner-page",attrs:{"id":_vm.pageName}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }